import { ISpecialProjectData } from '../types/specialProjects';

export const SPECIAL_PROJECTS: { [key: string]: ISpecialProjectData } = {
  pik: {
    icon: 'https://cdn.cian.site/media/images/pik_orange.svg',
    text: 'Показать ЖК от ПИК',
  },
};
